import React, { useState } from 'react'
import Pdf from '../../../../../../Components/Icons/Pdf'
import Filter from '../../../../../../Components/Icons/Filter'
import CloseIcon from '../../../../../../Components/Icons/Close'
import { CancelButton, SubmitButton } from '../../../../../../Components/Utils/Buttons'
import { useFormik } from 'formik'
import axiosInstance from '../../../../../../Services/axiosCommon'

import FormikSelectTwo, { FormikSelectTwoSmall } from '../../../../../../Components/Utils/Select'
import { NuDate, NuDateSmall,  } from '../../../../../../Components/Utils/Input'
import UseDropDown from '../../../../../../Components/Hooks/useDropDown'
import NuDateFormat from '../../../../../../Components/Utils/NuDate'
import Xls from '../../../../../../Components/Icons/Xls'
import NuAmount from '../../../../../../Components/Utils/NuAmount'
import NewReportTable from '../../../../../../Components/Others/NewReportTable'
import UseFetchReportData from '../../../../../../Components/Hooks/useFetchReportData'
import DropDownAddMetaData from '../../../../../../Components/Utils/selectAddMetaData'
import useFetchMataData from '../../../../../../Components/Hooks/useFetchMataData'
import { Link } from 'react-router-dom'
import { DownloadPDF, DownloadXLXS } from '../../../../../../Components/Utils/Download'

function SupportTicketsReport() {
    const [showFilter,setShowFilter] = useState(false)
    // const { data: RFQAssignee } = UseDropDown("/user/procurement/drop-down");
    const [filter, setFilter] = useState(false);
   
  const headers = [
    {
      title: "Ref.",
      width: "10%",
      field: "Ref",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Date",
      width: "10%",
      field: "Date",
      textAlign: "left",
      rowAlign: "left",
      type: "date",
    },
    {
      title: "Client",
      width: "10%",
      field: "Client",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Subject",
      width: "10%",
      field: "Subject",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Priority",
      width: "10%",
      field: "Priority",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Assignee",
      width: "10%",
      field: "Assignees",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Status",
      width: "10%",
      field: "Status",
      textAlign: "left",
      rowAlign: "left",
    },
  ];


        const [filterProps, setFilterProps] = useState({
          status:"",
          dateFrom:"",
          dateTo:"",
          priority:""
        });

        const [params, setParams] = useState({
          status:"",
          dateFrom:"",
          dateTo:"",
          priority:""
           
        });

       const formik = useFormik({
         enableReinitialize: true,
         initialValues: filterProps,
         validateOnChange: false,
         validateOnBlur: false,
         onSubmit: async (value) => {
           await new Promise((resolve) => setTimeout(resolve, 300)); // give Formik time to set isSubmitting
           setParams({
            status:value.status||"",
            dateFrom:value.dateFrom||"",
            dateTo:value.dateTo||"",
            priority:value.priority||""
           })
           setTimeout(() => {
            setFilter(true)
            // closeFilterDialog();
           }, 1000);
         }
       }) 
       const {data,getData,dataLoading,total,other} = UseFetchReportData("/xlsx-report/filter-support-tickets",params)


       function closeFilterDialog(){
         setShowFilter(false)
         formik.resetForm()
         setFilter(false)
         setParams({
          status:"",
          dateFrom:"",
          dateTo:"",
          priority:""
         })
       }





  

       const { value: Status, getData: refStatus } = useFetchMataData(
        `/dropdown/dropdown-details/`,
        "Status_Support_Tickets"
      );

        const { value: Priority,getData:refPriority } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "priority"
  );  
  return (
    <>
      <div className="w-full h-full overflow-scroll">
                <div className="flex gap-x-2 justify-between  w-full  py-2">
                  <div className=" max-w-[300px] pr-7 ">
                    <p className=" font-semibold text-xs 2xl:text-sm  ">
                      Support Tickets Report : {data?.length}
                    </p>
                  </div>
                  <div className=" flex-1 ">
                    <form onSubmit={formik.handleSubmit}>
                      <div className=" w-full grid grid-cols-5  gap-3">
                        <NuDateSmall
                          label="From "
                          placeholder="dd/mm/yyyy"
                          formik={formik}
                          name="dateFrom"
                          width="w-full"
                        />
                        <NuDateSmall
                          label="To "
                          placeholder="dd/mm/yyyy"
                          formik={formik}
                          name="dateTo"
                          width="w-full"
                        />
        
                        <FormikSelectTwoSmall
                          label="Priority"
                          Options={Priority}
                          formik={formik}
                          placeholder="Choose"
                          name="priority"
                          width="w-full"
                          displayProperty={"Priority"}
                          propertyName={"priority"}
                          getFunc={refPriority}
                        />
        
                        <FormikSelectTwoSmall
                          label="Status"
                          Options={Status}
                          formik={formik}
                          placeholder="Choose"
                          name="status"
                          width="w-full "
                        />
                        <div className=" w-full flex justify-end ">
                          <div className=" w-full flex items-end gap-2">
                          <SubmitButton name="Apply" isLoading={formik.isSubmitting} />

                            <CancelButton
                              label="Clear"
                              handleClick={closeFilterDialog}
                            />
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                  <div className=" w-[80px] flex justify-end items-end gap-4 ">
                    <DownloadPDF
                      url={`/xlsx-report/export-support-ticket-pdf`}
                      fileName="Support Ticket Report"
                      params={params}
                    />
                    <DownloadXLXS
                      url={`/xlsx-report/export-support-ticket-excel`}
                      fileName="Support Ticket Report"
                      params={params}
                    />
                  </div>
                </div>
        <NewReportTable headers={headers} data={data} dataLoading={dataLoading} />
       </div>  
    </>
  );
}

export default SupportTicketsReport